import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { CircleHelp } from "lucide-react";
import { Illustration } from "~/assets/Illustration";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/clickncollect/email")({
	beforeLoad: () => {
		document.title = 'bacehub | Startseite'
	},
	component: RouteComponent,
});

function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer>
			<AppHeader service="CLICK_N_COLLECT" />
			<div className="mx-auto max-w-xl px-6">
				<div className="flex flex-col gap-4">
					<h1 className="text-2xl font-normal tracking-tight">
						<T>{i18n.CHECK_INBOX_PICKUP_EMAIL()}</T>
					</h1>
					<p className="text-sm text-muted-foreground">
						<T>{i18n.CHECK_INBOX_PICKUP_EMAIL_DESC()}</T>
					</p>
					<div className="flex items-center justify-center p-6">
						<Illustration className="size-32" />
					</div>
				</div>
			</div>
			<div className="fixed bottom-6 left-0 right-0 flex w-full items-center justify-center">
				<Button variant="ghost" size="lg" asChild>
					<Link to="/support/how-to-use/click-and-collect">
						<CircleHelp className="mr-2 size-4" />
						<T>{i18n.HOW_DOES_CLICK_AND_COLLECT_WORK()}</T>
					</Link>
				</Button>
			</div>
		</PageContainer>
	);
}
